export default __webpack_public_path__ + "static/media/pg.icon.8a6a92c6.svg";